import Character from "../../Character";
import WorldbuildingEntry from "../../WorldbuildingEntry";
import TrashedChat from "./TrashedChat";

export default ({ item }) => {
  if (item.type === "character") {
    return (
      <Character
        key={`character:${item.item.id}`}
        initialCharacter={item.item}
        readOnly
      />
    );
  }
  if (item.type === "element") {
    return (
      <WorldbuildingEntry
        key={`element:${item.item.id}`}
        entry={item.item}
        customDefaults={[]}
        derivedRoles={[]}
        readOnly
      />
    );
  }
  if (item.type === "chat") {
    return <TrashedChat chat={item.item} />;
  }
  return <div>Unknown Trashed Item {item.type}</div>;
};
